import React from 'react';
import ProjectPopupItem from './project-popup-item';

class ProjectPopupBody extends React.Component {
  render(){
    const { feature, onItemClick } = this.props;
    const features = feature.get('features');
    return (
      <div>
        <ul className="cm-popup thin-scrollbar" style={{maxHeight: '350px', overflowY: 'auto'}}>
          {
            features.map((f, i) => {
              return <ProjectPopupItem key={i} feature={f} onClick={onItemClick}/>
            })
          }
        </ul>
      </div>
    )

  }
}

export default ProjectPopupBody;